module.exports = function() {
  return new Worker(__webpack_public_path__ + "processData.667a0db666e11a577ea7.js");
};